import { useState, useContext } from "react";
import { PaystackButton } from "react-paystack";
import {
  FaWallet, FaPlusCircle, FaUniversity, FaExchangeAlt,
  FaRegFolderOpen, FaTimes, FaGift, FaUserFriends, FaRegCopy
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import '../styles/wallet.css';
import { AuthContext } from "../context/AuthContext";


import axios from "axios";

const Wallet = () => {
  const { currentUser} = useContext(AuthContext);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/bank-account"); // Navigates to the bank account page
  };

   const fundsNavigate = () => {
    navigate("/add-funds"); // Navigates to the bank account page
  };

  const handleWithdraw = async () =>{
    navigate('/withdraw')
  }

  return (
    <div className="wallet-container">
      {/* Wallet Box */}
      <div className="wallet-box">
        {/* Account Balance Section */}
        <div className="wallet-cards">
          {/* Wallet Balance */}
          <div className="wallet-card">
            <div className="wallet-card-icon">
              <FaWallet />
            </div>
            <div className="wallet-card-content">
              <div className="wallet-card-label">Wallet Balance</div>
              <div className="wallet-card-value">₦ {currentUser?.balance || "0.00"}</div>
            </div>
          </div>

          {/* Referral Bonus */}
          <div className="wallet-card">
            <div className="wallet-card-icon">
              <FaGift />
            </div>
            <div className="wallet-card-content">
              <div className="wallet-card-label">Referral Bonus</div>
              <div className="wallet-card-value">₦ {currentUser?.referralBonus || "0.00"}</div>
            </div>
          </div>

          {/* Total Referrals */}
          <div className="wallet-card">
            <div className="wallet-card-icon">
              <FaUserFriends />
            </div>
            <div className="wallet-card-content">
              <div className="wallet-card-label">My Total Referrals</div>
              <div className="wallet-card-value">{currentUser?.totalReferrals || "0"}</div>
            </div>
          </div>
        </div>


        {/* Wallet Action Buttons */}
        <div className="wallet-actions">
          {/* Add Funds Button */}
          <button className="wallet-btn" onClick={fundsNavigate}>
            <FaPlusCircle size={22} /> Add Funds
          </button>

          {/* Withdraw Button */}
          <button className="wallet-btn" onClick={handleWithdraw}>
            <FaExchangeAlt size={22} /> Withdraw
          </button>

          {/* Bank Account Placeholder */}
          <button className="wallet-btn" onClick={handleClick}>
            <FaUniversity size={22} /> Bank Account
          </button>
        </div>

      </div>
    </div>
  );
};

export default Wallet;
